import React from "react";
import PropTypes from "prop-types";
import style from "../../stylesheets/StoreFilter.module.scss";
import mobileStyle from "../../stylesheets/MobileFilter.module.scss";
import BrandFilterOption from "./BrandFilterOption";
import { BRAND_PSEUDO_FACET_ID } from "../../constants";

const BrandFilter = ({
  selectedDropdown,
  showDropdown,
  isMobile,
  brandParamsName,
  handleFilterClick,
}) => {
  if (brandParamsName.length === 0) {
    return null;
  }

  const handleClickDropdown = () => {
    showDropdown(BRAND_PSEUDO_FACET_ID);
  };

  const selectedDropdownClass =
    selectedDropdown === BRAND_PSEUDO_FACET_ID ? style.selectedDropdown : null;

  const selectedDropdownIcon =
    selectedDropdown === BRAND_PSEUDO_FACET_ID ? "Up" : "Down";

  const brandOptions = brandParamsName.map((brand) => {
    if (brand !== undefined) {
      return (
        <BrandFilterOption
          key={brand.id}
          filterOption={brand}
          showDropdown={showDropdown}
          isMobile={isMobile}
          handleFilterClick={handleFilterClick}
        />
      );
    }
  });

  return isMobile ? (
    <div className={mobileStyle.filterWrapper}>
      Brand
      <div className={mobileStyle.categoryFilterDropdown} tabIndex="0">
        <div id="brand-loading" className={style.categoryLoading} />
        <ul>{brandOptions}</ul>
      </div>
    </div>
  ) : (
    <div className={style.filterWrapper} tabIndex="0">
      <div className={style.filterTitle} onClick={handleClickDropdown}>
        Brand
        <img
          className={style.dropdownIcon}
          src={`https://cdn-s3.touchofmodern.com/images/icons/icon_filter${selectedDropdownIcon}Arrow%402x.png`}
          alt="filterArrow"
        />
      </div>
      <div
        className={`${style.filterDropdown} ${style.priceDropdown} ${selectedDropdownClass}`}
      >
        {brandOptions}
      </div>
    </div>
  );
};

BrandFilter.propTypes = {
  selectedDropdown: PropTypes.number.isRequired,
  showDropdown: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  brandParamsName: PropTypes.array.isRequired,
  handleFilterClick: PropTypes.func.isRequired,
};

export default BrandFilter;
